import instance from '../../../api/axios'
export const getParticipants = async (eventId?: string): Promise<any[]> => {
  const params = eventId ? { eventId } : {}
  const response = await instance.get('/wedding/participants', { params })
  return response.data || []
}
